import React from 'react';
import {
  Container, Image
} from 'react-bootstrap';
import { Tron } from './Tron';

export const Ios = () => {
  
  let homeTron = {
    title: 'Workspace ONE iOS Excel Add-In (Beta)',
    description: 'This is the installation documentation page for the Workspace ONE iOS Excel Add-In.',
    body: <>
      <p>This covers using this website to run the Add-In.</p>
      <p><b>However,</b> this is mostly for evaluation purposes since, for security and privacy reasons,
        there is no caching layer implemented at this time so your speed will be much higher
        with a <a href='./APIBackendWindows'>Caching API implemented</a></p>
      <p>This is easier than you think.</p>
    </>
  };
  
  
  return (
    
    <Container>
      <Tron tronProps={homeTron}/>
      <Container>
        <h4 id="copy-and-edit-manifest.xml">Copy and edit Manifest.xml</h4>
        <p>The first thing you need to do is go to the <a
          href="https://github.com/vmware-samples/euc-samples">VMware Samples GitHub</a> and download the euc-samples
          repository. Once downloaded, unzip it, and open the euc-samples-master folder, then Windows-Samples,
          Tools &amp; Utilities, and finally Excel Add-In.</p>
        <p>Copy the manifest.xml to a temporary folder on your computer</p>
        <h5>Edit the manifest.xml</h5>
        <Image alt="Edit Manifest" width='800' src='../images/WSONEEditManifest.png' fluid/>
        <ul>
          <li>Right click on the manifest.xml and click edit</li>
          <li>Click Open the Edit menu and click Replace</li>
          <li>In "Find What" put /localhost/</li>
          <li>In "Replace With" put /wsonereporting.azurewebsites.net/</li>
          <li>Click "Replace All"</li>
          <li>Save your manifest.xml</li>
        </ul>
        
        <h4>Setup your Add-In</h4>
        
        <ul>
          <li>
            <p>Use a sync cable to connect your iPad to your computer. If you're connecting the iPad to your
              computer for the first time, you'll be prompted with "Trust This Computer". Choose Trust to
              continue.</p>
          </li>
          <li>
            <p>In iTunes, choose the iPad icon below the menu bar.</p>
          </li>
          <li>
            <p>Under Settings on the left side of iTunes, choose Apps.</p>
          </li>
          <li>
            <p>On the right side of iTunes, scroll down to File Sharing, and then choose Excel in the
              Add-ins column.</p>
          </li>
          <li>
            <p>At the bottom of the Excel Document column, choose Add File, and then select the manifest.xml
              file.</p>
          </li>
          <li>
            <p>Open the Excel app on your iPad. If the Excel app is already running, choose the Home
              button, and then close and restart the app.</p>
          </li>
          <li>
            <p>Open a document.</p>
          </li>
          <li>
            <p>Choose Add-ins on the Insert tab. Your Workspace ONE Add-In is available to insert under the
              Developer
              heading in the Add-ins UI.</p>
            <img src="../images/WSOneiOSAddIn.png" alt="Insert Addin" height="500"/>
          </li>
        </ul>
      
      </Container>
    </Container>
  );
};

